import { get, post } from './request'
import { getQueryString } from '@/utils/tools'

const token = localStorage.getItem('token')
const orgId = getQueryString('orgid')
const questionActiveKey = getQueryString('questionActiveKey')

// 获取问卷统计数据
export const getAnswerStatistics = (data) => {
  return post('/answer/get_answer_statistics', data)
}

// 获取个人管理的学校列表
export const getSchoolListByUser = (data) => {
  return get('/question_active/level_manager', {
    token,
    orgId,
    ...data,
  })
}

// 获取总的问卷统计数据
export const getAnswerStatisticsTotal = (data) => {
  return get('/question_active/school_total', data)
}

// 填报记录
export const getAnswerRecordList = (data) => {
  return get('/question_active/school_record', data)
}

// 获取填报记录详情
export const getAnswerRecordDetail = (data) => {
  return get('/question_active/record_detail', data)
}

// 获取填空题答案
export const getAnswerRecordBlank = (data) => {
  return get('/answer/get_answer_detail', data)
}

// 获取amdin填报管理权限
export const getAdminAuth = (data) => {
  return get('/question_active/manage_check', {
    token,
    questionActiveKey,
    ...data,
  })
}

// 导出数据
export const exportAnswerRecord = (data, config = {}) => {
  return get('/question_active/school_export', data, config)
}
